import { ConcreteEncodable } from "./ConcreteEncodable";

import { UserImplEncoder } from "../../encoder/UserImplEncoder";

import * as CubiqTS from "../../index";
import { User } from "../User";

export class UserImpl extends ConcreteEncodable implements User {
  public static enType: string = "com.bcdfx.model.UserImpl";

  /*FID=1*/
  public clientCode: string;
  /*FID=2*/
  public userCode: string;
  /*FID=3*/
  public userId: CubiqTS.Long | null = null;
  /*FID=4*/
  public userName: string;
  /*FID=5*/
  public userType: CubiqTS.UserType;
  /*FID=6*/
  public branchCode: string;
  /*FID=7*/
  public authProvider: string;
  /*FID=8*/
  public emailAddress: string;
  /*FID=9*/
  public smsNumber: string;
  /*FID=10*/
  public sendEmailMyOrdEnteredFg: boolean;
  /*FID=11*/
  public sendSMSMyOrdEnteredFg: boolean;
  /*FID=12*/
  public sendEmailMyOrdFillFg: boolean;
  /*FID=13*/
  public sendSMSMyOrdFillFg: boolean;
  /*FID=14*/
  public sendEmailMyOrdExpiryFg: boolean;
  /*FID=15*/
  public sendSMSMyOrdExpiryFg: boolean;
  /*FID=16*/
  public sendEmailAnyOrderIFillFg: boolean;
  /*FID=17*/
  public sendSMSAnyOrderIFillFg: boolean;
  /*FID=18*/
  public clientCodes: Array<string> | null = null;
  /*FID=19*/
  public desk: string;
  /*FID=20*/
  public comment: string;
  /*FID=21*/
  public isDefault: boolean;
  /*FID=22*/
  public sendEmailMyOrdModifyFg: boolean;
  /*FID=23*/
  public sendSMSMyOrdModifyFg: boolean;
  /*FID=24*/
  public sendEmailMyOrdCancelFg: boolean;
  /*FID=25*/
  public sendSMSMyOrdCancelFg: boolean;
  /*FID=26*/
  public roles: Array<string> | null = null;
  /*FID=27*/
  public cmeEbsId: string;
  /*FID=28*/
  public cmeEbsLocation: string;
  /*FID=29*/
  public uiEnabledFg: boolean;
  /*FID=30*/
  public defaultPublicProfileId: CubiqTS.Long | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = UserImplEncoder.Instance;
    this.setEncodableType(UserImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "UserImpl[" +
      "clientCode=" +
      this.clientCode +
      "userCode=" +
      this.userCode +
      "userId=" +
      this.userId +
      "userName=" +
      this.userName +
      "userType=" +
      this.userType +
      "branchCode=" +
      this.branchCode +
      "authProvider=" +
      this.authProvider +
      "emailAddress=" +
      this.emailAddress +
      "smsNumber=" +
      this.smsNumber +
      "sendEmailMyOrdEnteredFg=" +
      this.sendEmailMyOrdEnteredFg +
      "sendSMSMyOrdEnteredFg=" +
      this.sendSMSMyOrdEnteredFg +
      "sendEmailMyOrdFillFg=" +
      this.sendEmailMyOrdFillFg +
      "sendSMSMyOrdFillFg=" +
      this.sendSMSMyOrdFillFg +
      "sendEmailMyOrdExpiryFg=" +
      this.sendEmailMyOrdExpiryFg +
      "sendSMSMyOrdExpiryFg=" +
      this.sendSMSMyOrdExpiryFg +
      "sendEmailAnyOrderIFillFg=" +
      this.sendEmailAnyOrderIFillFg +
      "sendSMSAnyOrderIFillFg=" +
      this.sendSMSAnyOrderIFillFg +
      "clientCodes=" +
      this.clientCodes +
      "desk=" +
      this.desk +
      "comment=" +
      this.comment +
      "isDefault=" +
      this.isDefault +
      "sendEmailMyOrdModifyFg=" +
      this.sendEmailMyOrdModifyFg +
      "sendSMSMyOrdModifyFg=" +
      this.sendSMSMyOrdModifyFg +
      "sendEmailMyOrdCancelFg=" +
      this.sendEmailMyOrdCancelFg +
      "sendSMSMyOrdCancelFg=" +
      this.sendSMSMyOrdCancelFg +
      "roles=" +
      this.roles +
      "cmeEbsId=" +
      this.cmeEbsId +
      "cmeEbsLocation=" +
      this.cmeEbsLocation +
      "uiEnabledFg=" +
      this.uiEnabledFg +
      "defaultPublicProfileId=" +
      this.defaultPublicProfileId +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
